<template>
  <div
    class="content"
    @touchstart="exibirCirculos"
    @touchmove="exibirCirculos"
    @touchend="limparCirculos"
  >
    <h2 class="title" style="color: white;">
      {{ $t("mainTitle") }}
    </h2>
    <base-modal
      :title="modalTitle"
      :message="modalMessage"
      :showModal="showModal"
      @close-modal="showModal = false"
    />
    <div
      v-for="circulo in circulos"
      :key="circulo.identificador"
      class="circle"
      :style="{
        top: circulo.topo + 'px',
        left: circulo.esquerda + 'px',
        'background-color': cores[circulo.identificador],
      }"
    ></div>

    <div
      class="circle"
      v-if="Object.keys(circuloSelecionado).length > 1"
      :style="{
        top: circuloSelecionado.topo + 'px',
        left: circuloSelecionado.esquerda + 'px',
        'background-color': circuloSelecionado.cor,
      }"
    >
      <img
        src="/beer-icon.png"
        class="imagem-centro-circulo"
        :alt="$t('home.subtitle')"
      />
    </div>
    <div
      class="texto-centralizado"
      @click="reiniciarJogo"
      @touchstart="reiniciarJogo"
    >
      {{ centralMessage }}
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

import ShareFooter from "src/components/ShareFooter.vue";

export default {
  mixins: [mixin],

  components: {
    ShareFooter,
  },

  data() {
    return {
      circulos: [],
      touchDesabilitado: false,
      cores: {},
      valorInicialContador: 5,
      contador: 0,
      contando: false,
      circuloSelecionado: { cor: "#fff952" },
    };
  },

  computed: {
    centralMessage() {
      if (this.contando) return this.contador;
      if (this.touchDesabilitado)
        return this.$t("fingerSelector.centralMessage.restart");
      if (this.circulos.length === 0)
        return this.$t("fingerSelector.centralMessage.pressScreen");
      if (this.circulos.length === 1)
        return this.$t("fingerSelector.centralMessage.anotherFinger");
    },
  },

  beforeMount() {
    this.contador = this.valorInicialContador;
  },
  watch: {
    contando(valorNovo, valorAntigo) {
      if (valorNovo === true && valorAntigo === false) {
        this.iniciarContagem();
      } else {
        this.resetarContagem();
      }
    },
    contador(valor) {
      if (valor === 0) {
        this.circuloSelecionado = {
          ...this.circuloSelecionado,
          ...this.circulos[Math.floor(Math.random() * this.circulos.length)],
        };
        this.contando = false;
        this.circulos = {};
        this.touchDesabilitado = true;
      }
    },
  },

  methods: {
    reiniciarJogo() {
      if (this.touchDesabilitado) {
        this.circuloSelecionado = { cor: "#fff952" };
        this.contador = this.valorInicialContador;
        this.touchDesabilitado = false;
      }
    },
    diminuirContador() {
      this.contador--;
    },
    iniciarContagem() {
      this.intervalContador = setInterval(this.diminuirContador, 1000);
    },
    resetarContagem() {
      clearInterval(this.intervalContador);
      this.contador = this.valorInicialContador;
      this.contando = false;
    },
    selecionaCorAleatoria() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    exibirCirculos: function(event) {
      if (this.touchDesabilitado) return;
      if (this.circulos.length > 1) this.contando = true;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.circulos = [];
      Array.prototype.forEach.call(event.touches, (touch) => {
        const item = {};
        item.identificador = touch.identifier;
        item.topo = touch.clientY - 60;
        item.esquerda = touch.clientX - 60;
        this.circulos.push(item);
      });

      Array.prototype.forEach.call(this.circulos, (circulo) => {
        if (!this.cores[circulo.identificador]) {
          this.cores[circulo.identificador] = this.selecionaCorAleatoria();
        }
      });
    },
    limparCirculos: function(event) {
      const dedosPersistentes = event.touches.length
        ? event.touches.map((toque) => toque.identifier)
        : [];
      this.circulos = this.circulos.length
        ? this.circulos.filter(
            (circulo) => circulo.identificador in dedosPersistentes
          )
        : [];
      if (this.circulos.length < 2) this.resetarContagem();
      if (this.circulos.length === 0) this.cores = {};
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
.description {
  text-align: left;
}
.page {
  margin: 100px auto 0;
  width: 500px;
  display: flex;
  justify-content: space-between;
}

.circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  position: absolute;
  background-color: #333;
}

.texto-centralizado {
  position: absolute;
  top: 40%;
  left: 50%;
  font-size: 24px;
  color: white;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
}

.imagem-centro-circulo {
  position: absolute;
  top: 35px;
  left: 35px;
  width: 50px;
}
</style>
